<template>
  <div class="privacy-policy">
    <div class="container">
      <h1>PRIVACY POLICY﻿</h1>
      Here at Smart we are dedicated to protecting you. Privacy should be the most important factor that should be treasured between a company and their users.<br/><br/>
      The information we collect from you , including your name, address, email and so forth is used transparently, with no secrets and hidden agendas.<br/><br/>
      Although we do sometimes hire other companies to provide services on our behalf, which means occasionally, your information will be shared however, Smart! guarantees that your information will not go any further.
      What services the notice applies to?<br/><br/>
      This service applies to a wide range of services on our website, including the purchasing of our goods and any subscriptions you sign up for.<br/><br/>
      If you have any further queries or questions regarding our policy do not hesitate to contact us at info@smart-fertilizer.com<br/><br/>
      Who we are?<br/><br/>
      Here at Smart Fertilizer Software we deliver a range of services including Fertilizer Software tools that agriculturalists and farmers can make use of.<br/><br/>
      Our software has been tested and used professionally in producing better ways of helping our customers and clients.<br/><br/>
      What information do we collect?<br/><br/>
      The types of data we collect ranges from your name, address, email address, phone number and any other information that is considered sensitive, which is defined below.<br/><br/>
      We collect data when a user registers, purchasers and signs up to any other information regarding our company.<br/><br/>
      The information we collect is indeed sensitive however we protect this at all costs.<br/><br/>
      According to an EU Directive under Art 2(a), personal data is defined as:<br/><br/>
          <br/><br/>• Any information relating to an identified or identifiable natural person; an identifiable person is one who can be identified, directly or indirectly in particular by referenced to an identification number or to one or more factors specific to his or her physical, physiological, mental, economic, cultural or social identity.
      <br/><br/>How do we use personal information?
          <br/><br/>• Personalisation of content, business information or user experience
          <br/><br/>• Account set up and administration
          <br/><br/>• Delivering marketing and events communication
          <br/><br/>• Carrying out polls and surveys
          <br/><br/>• Internal research and development purposes
          <br/><br/>• Providing goods and services
          <br/><br/>• Legal obligations (e.g. prevention of fraud)
          <br/><br/>• Meeting internal audit requirements
      <br/><br/>What legal basis do we have for processing your personal data?
          <br/><br/>• Consent – this can be withdrawn by a quick and simple email to info@smartfertilizer.com
          <br/><br/>• Contract
          <br/><br/>• Legitimate interests
          <br/><br/>• Vital interests
          <br/><br/>• Public task
          <br/><br/>• Legal obligation
      <br/><br/>When do we share personal data?
      At Smart we treat each individual’s personal data confidentially and will only release this information when we hire third party companies in assisting us however we ensure you that your information will not be released to anyone else, as explained above.<br/><br/>
      Also, only when required by law will Smart disclose your information, nonetheless, you are safe using our services.<br/><br/>
      How do we secure personal data?
      We try our hardest through many measures to keep your personal information secured and it will not leave outside the company without your permission.<br/><br/>
      You also have a significant role in protecting your information. No one can see or edit your personal information without knowing your user name and password, so do not share these with others.<br/><br/>
      <br/><br/>How long do we keep your personal data for?
      <br/><br/>As required by the laws set out in the GDPR, particularly in Article 5(e) we do not withhold an individual’s information for no longer than reasonably necessary
      <br/><br/>Under the GDPR you have the following rights in relation to your personal data
          <br/><br/>• access to personal information
          <br/><br/>• correction and deletion
          <br/><br/>• withdrawal of consent (if processing data on condition of consent)
      <br/><br/>Use of automated decision-making and profiling
      <br/><br/>When you join us, you provide us with your contact information, including your name and email address.
      <br/><br/>We use this information to send you updates about your order, questionnaires to measure your satisfaction with our service and announcements about new and exciting services that we offer.
      <br/><br/>Use of cookies and other technologies
      <br/><br/>This site uses cookies for the purpose of its continuous operation, including in order to collect anonymous related data in order to use it for statistical purposes, for advertising and marketing to verify information to suit your needs (including the possibility to remain registered during the activity at the site), and more. If you do not wish to receive cookies, you can avoid it by changing your browser settings. You can use the browser’s help file to do so. However, disabling cookies may impair a range of services on site.
      <br/><br/>This is a link for «Clean cookies» settings.

    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.privacy-policy {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1100px;
  margin: 0 auto;
  padding: 16px 24px;
}
</style>
